/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CreateFlexibleBlockRequest } from '../model'
// @ts-ignore
import type { CreateYardBlockRequest } from '../model'
// @ts-ignore
import type { CreateYardBlockResponse } from '../model'
// @ts-ignore
import type { DeleteBayRequest } from '../model'
// @ts-ignore
import type { DeleteBayResponse } from '../model'
// @ts-ignore
import type { DeleteRowRequest } from '../model'
// @ts-ignore
import type { DeleteRowResponse } from '../model'
// @ts-ignore
import type { DeleteYardBlockRequest } from '../model'
// @ts-ignore
import type { GetYardBlocksResponse } from '../model'
// @ts-ignore
import type { InsertBayAfterRequest } from '../model'
// @ts-ignore
import type { InsertBayBeforeRequest } from '../model'
// @ts-ignore
import type { InsertBayResponse } from '../model'
// @ts-ignore
import type { InsertRowAfterRequest } from '../model'
// @ts-ignore
import type { InsertRowBeforeRequest } from '../model'
// @ts-ignore
import type { InsertRowResponse } from '../model'
// @ts-ignore
import type { RenameBayRequest } from '../model'
// @ts-ignore
import type { RenameBayResponse } from '../model'
// @ts-ignore
import type { RenameRowRequest } from '../model'
// @ts-ignore
import type { RenameRowResponse } from '../model'
// @ts-ignore
import type { UpdateEquipmentTypesRequest } from '../model'
// @ts-ignore
import type { UpdateFlexibleBlockRequest } from '../model'
// @ts-ignore
import type { UpdateYardBlockLayoutPositionRequest } from '../model'
// @ts-ignore
import type { UpdateYardBlockRequest } from '../model'
// @ts-ignore
import type { UpdateYardBlockResponse } from '../model'
/**
 * YardBlocksApi - axios parameter creator
 */
export const YardBlocksApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CreateFlexibleBlockRequest} [createFlexibleBlockRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createFlexibleBlock: async (
      createFlexibleBlockRequest?: CreateFlexibleBlockRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks/CreateFlexibleBlock`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createFlexibleBlockRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CreateYardBlockRequest} [createYardBlockRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createYardBlock: async (
      createYardBlockRequest?: CreateYardBlockRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createYardBlockRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {DeleteBayRequest} [deleteBayRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBay: async (
      deleteBayRequest?: DeleteBayRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks/DeleteBay`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteBayRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {DeleteRowRequest} [deleteRowRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteRow: async (
      deleteRowRequest?: DeleteRowRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks/DeleteRow`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteRowRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {DeleteYardBlockRequest} [deleteYardBlockRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteYardBlock: async (
      deleteYardBlockRequest?: DeleteYardBlockRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteYardBlockRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {Array<string>} [blockIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getYardBlocks: async (
      blockIds?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (blockIds) {
        localVarQueryParameter['BlockIds'] = blockIds
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {Array<string>} [blockNames]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getYardBlocksByNames: async (
      blockNames?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks/ByNames`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (blockNames) {
        localVarQueryParameter['BlockNames'] = blockNames
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {InsertBayAfterRequest} [insertBayAfterRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    insertBayAfter: async (
      insertBayAfterRequest?: InsertBayAfterRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks/InsertBayAfter`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        insertBayAfterRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {InsertBayBeforeRequest} [insertBayBeforeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    insertBayBefore: async (
      insertBayBeforeRequest?: InsertBayBeforeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks/InsertBayBefore`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        insertBayBeforeRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {InsertRowAfterRequest} [insertRowAfterRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    insertRowAfter: async (
      insertRowAfterRequest?: InsertRowAfterRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks/InsertRowAfter`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        insertRowAfterRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {InsertRowBeforeRequest} [insertRowBeforeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    insertRowBefore: async (
      insertRowBeforeRequest?: InsertRowBeforeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks/InsertRowBefore`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        insertRowBeforeRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {RenameBayRequest} [renameBayRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    renameBay: async (
      renameBayRequest?: RenameBayRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks/RenameBay`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        renameBayRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {RenameRowRequest} [renameRowRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    renameRow: async (
      renameRowRequest?: RenameRowRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks/RenameRow`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        renameRowRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateEquipmentTypesRequest} [updateEquipmentTypesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEquipmentTypes: async (
      updateEquipmentTypesRequest?: UpdateEquipmentTypesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks/AssignedEquipmentTypes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateEquipmentTypesRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateFlexibleBlockRequest} [updateFlexibleBlockRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFlexibleBlock: async (
      updateFlexibleBlockRequest?: UpdateFlexibleBlockRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks/UpdateFlexibleBlock`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateFlexibleBlockRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateYardBlockRequest} [updateYardBlockRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateYardBlock: async (
      updateYardBlockRequest?: UpdateYardBlockRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateYardBlockRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateYardBlockLayoutPositionRequest} [updateYardBlockLayoutPositionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateYardBlockLayoutPosition: async (
      updateYardBlockLayoutPositionRequest?: UpdateYardBlockLayoutPositionRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardBlocks/UpdateLayoutPosition`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateYardBlockLayoutPositionRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * YardBlocksApi - functional programming interface
 */
export const YardBlocksApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = YardBlocksApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {CreateFlexibleBlockRequest} [createFlexibleBlockRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createFlexibleBlock(
      createFlexibleBlockRequest?: CreateFlexibleBlockRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateYardBlockResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createFlexibleBlock(
        createFlexibleBlockRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.createFlexibleBlock']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CreateYardBlockRequest} [createYardBlockRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createYardBlock(
      createYardBlockRequest?: CreateYardBlockRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateYardBlockResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createYardBlock(
        createYardBlockRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.createYardBlock']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {DeleteBayRequest} [deleteBayRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteBay(
      deleteBayRequest?: DeleteBayRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteBayResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBay(deleteBayRequest, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.deleteBay']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {DeleteRowRequest} [deleteRowRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteRow(
      deleteRowRequest?: DeleteRowRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteRowResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRow(deleteRowRequest, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.deleteRow']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {DeleteYardBlockRequest} [deleteYardBlockRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteYardBlock(
      deleteYardBlockRequest?: DeleteYardBlockRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteYardBlock(
        deleteYardBlockRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.deleteYardBlock']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {Array<string>} [blockIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getYardBlocks(
      blockIds?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetYardBlocksResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getYardBlocks(blockIds, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.getYardBlocks']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {Array<string>} [blockNames]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getYardBlocksByNames(
      blockNames?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetYardBlocksResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getYardBlocksByNames(
        blockNames,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.getYardBlocksByNames']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {InsertBayAfterRequest} [insertBayAfterRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async insertBayAfter(
      insertBayAfterRequest?: InsertBayAfterRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsertBayResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.insertBayAfter(
        insertBayAfterRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.insertBayAfter']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {InsertBayBeforeRequest} [insertBayBeforeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async insertBayBefore(
      insertBayBeforeRequest?: InsertBayBeforeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsertBayResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.insertBayBefore(
        insertBayBeforeRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.insertBayBefore']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {InsertRowAfterRequest} [insertRowAfterRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async insertRowAfter(
      insertRowAfterRequest?: InsertRowAfterRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsertRowResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.insertRowAfter(
        insertRowAfterRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.insertRowAfter']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {InsertRowBeforeRequest} [insertRowBeforeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async insertRowBefore(
      insertRowBeforeRequest?: InsertRowBeforeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsertRowResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.insertRowBefore(
        insertRowBeforeRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.insertRowBefore']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {RenameBayRequest} [renameBayRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async renameBay(
      renameBayRequest?: RenameBayRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RenameBayResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.renameBay(renameBayRequest, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.renameBay']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {RenameRowRequest} [renameRowRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async renameRow(
      renameRowRequest?: RenameRowRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RenameRowResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.renameRow(renameRowRequest, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.renameRow']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateEquipmentTypesRequest} [updateEquipmentTypesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateEquipmentTypes(
      updateEquipmentTypesRequest?: UpdateEquipmentTypesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateEquipmentTypes(
        updateEquipmentTypesRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.updateEquipmentTypes']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateFlexibleBlockRequest} [updateFlexibleBlockRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateFlexibleBlock(
      updateFlexibleBlockRequest?: UpdateFlexibleBlockRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateYardBlockResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateFlexibleBlock(
        updateFlexibleBlockRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.updateFlexibleBlock']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateYardBlockRequest} [updateYardBlockRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateYardBlock(
      updateYardBlockRequest?: UpdateYardBlockRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateYardBlockResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateYardBlock(
        updateYardBlockRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.updateYardBlock']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateYardBlockLayoutPositionRequest} [updateYardBlockLayoutPositionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateYardBlockLayoutPosition(
      updateYardBlockLayoutPositionRequest?: UpdateYardBlockLayoutPositionRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateYardBlockLayoutPosition(
        updateYardBlockLayoutPositionRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.updateYardBlockLayoutPosition']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * YardBlocksApi - factory interface
 */
export const YardBlocksApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = YardBlocksApiFp(configuration)
  return {
    /**
     *
     * @param {CreateFlexibleBlockRequest} [createFlexibleBlockRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createFlexibleBlock(
      createFlexibleBlockRequest?: CreateFlexibleBlockRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateYardBlockResponse> {
      return localVarFp
        .createFlexibleBlock(createFlexibleBlockRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CreateYardBlockRequest} [createYardBlockRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createYardBlock(
      createYardBlockRequest?: CreateYardBlockRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateYardBlockResponse> {
      return localVarFp
        .createYardBlock(createYardBlockRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {DeleteBayRequest} [deleteBayRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBay(
      deleteBayRequest?: DeleteBayRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DeleteBayResponse> {
      return localVarFp
        .deleteBay(deleteBayRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {DeleteRowRequest} [deleteRowRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteRow(
      deleteRowRequest?: DeleteRowRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DeleteRowResponse> {
      return localVarFp
        .deleteRow(deleteRowRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {DeleteYardBlockRequest} [deleteYardBlockRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteYardBlock(
      deleteYardBlockRequest?: DeleteYardBlockRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteYardBlock(deleteYardBlockRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {Array<string>} [blockIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getYardBlocks(
      blockIds?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetYardBlocksResponse> {
      return localVarFp.getYardBlocks(blockIds, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {Array<string>} [blockNames]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getYardBlocksByNames(
      blockNames?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetYardBlocksResponse> {
      return localVarFp
        .getYardBlocksByNames(blockNames, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {InsertBayAfterRequest} [insertBayAfterRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    insertBayAfter(
      insertBayAfterRequest?: InsertBayAfterRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<InsertBayResponse> {
      return localVarFp
        .insertBayAfter(insertBayAfterRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {InsertBayBeforeRequest} [insertBayBeforeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    insertBayBefore(
      insertBayBeforeRequest?: InsertBayBeforeRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<InsertBayResponse> {
      return localVarFp
        .insertBayBefore(insertBayBeforeRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {InsertRowAfterRequest} [insertRowAfterRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    insertRowAfter(
      insertRowAfterRequest?: InsertRowAfterRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<InsertRowResponse> {
      return localVarFp
        .insertRowAfter(insertRowAfterRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {InsertRowBeforeRequest} [insertRowBeforeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    insertRowBefore(
      insertRowBeforeRequest?: InsertRowBeforeRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<InsertRowResponse> {
      return localVarFp
        .insertRowBefore(insertRowBeforeRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {RenameBayRequest} [renameBayRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    renameBay(
      renameBayRequest?: RenameBayRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<RenameBayResponse> {
      return localVarFp
        .renameBay(renameBayRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {RenameRowRequest} [renameRowRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    renameRow(
      renameRowRequest?: RenameRowRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<RenameRowResponse> {
      return localVarFp
        .renameRow(renameRowRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateEquipmentTypesRequest} [updateEquipmentTypesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEquipmentTypes(
      updateEquipmentTypesRequest?: UpdateEquipmentTypesRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .updateEquipmentTypes(updateEquipmentTypesRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateFlexibleBlockRequest} [updateFlexibleBlockRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFlexibleBlock(
      updateFlexibleBlockRequest?: UpdateFlexibleBlockRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UpdateYardBlockResponse> {
      return localVarFp
        .updateFlexibleBlock(updateFlexibleBlockRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateYardBlockRequest} [updateYardBlockRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateYardBlock(
      updateYardBlockRequest?: UpdateYardBlockRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UpdateYardBlockResponse> {
      return localVarFp
        .updateYardBlock(updateYardBlockRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateYardBlockLayoutPositionRequest} [updateYardBlockLayoutPositionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateYardBlockLayoutPosition(
      updateYardBlockLayoutPositionRequest?: UpdateYardBlockLayoutPositionRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .updateYardBlockLayoutPosition(updateYardBlockLayoutPositionRequest, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * YardBlocksApi - object-oriented interface
 */
export class YardBlocksApi extends BaseAPI {
  /**
   *
   * @param {CreateFlexibleBlockRequest} [createFlexibleBlockRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public createFlexibleBlock(
    createFlexibleBlockRequest?: CreateFlexibleBlockRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardBlocksApiFp(this.configuration)
      .createFlexibleBlock(createFlexibleBlockRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CreateYardBlockRequest} [createYardBlockRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public createYardBlock(
    createYardBlockRequest?: CreateYardBlockRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardBlocksApiFp(this.configuration)
      .createYardBlock(createYardBlockRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {DeleteBayRequest} [deleteBayRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteBay(deleteBayRequest?: DeleteBayRequest, options?: RawAxiosRequestConfig) {
    return YardBlocksApiFp(this.configuration)
      .deleteBay(deleteBayRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {DeleteRowRequest} [deleteRowRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteRow(deleteRowRequest?: DeleteRowRequest, options?: RawAxiosRequestConfig) {
    return YardBlocksApiFp(this.configuration)
      .deleteRow(deleteRowRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {DeleteYardBlockRequest} [deleteYardBlockRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteYardBlock(
    deleteYardBlockRequest?: DeleteYardBlockRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardBlocksApiFp(this.configuration)
      .deleteYardBlock(deleteYardBlockRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {Array<string>} [blockIds]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getYardBlocks(blockIds?: Array<string>, options?: RawAxiosRequestConfig) {
    return YardBlocksApiFp(this.configuration)
      .getYardBlocks(blockIds, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {Array<string>} [blockNames]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getYardBlocksByNames(blockNames?: Array<string>, options?: RawAxiosRequestConfig) {
    return YardBlocksApiFp(this.configuration)
      .getYardBlocksByNames(blockNames, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {InsertBayAfterRequest} [insertBayAfterRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public insertBayAfter(
    insertBayAfterRequest?: InsertBayAfterRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardBlocksApiFp(this.configuration)
      .insertBayAfter(insertBayAfterRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {InsertBayBeforeRequest} [insertBayBeforeRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public insertBayBefore(
    insertBayBeforeRequest?: InsertBayBeforeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardBlocksApiFp(this.configuration)
      .insertBayBefore(insertBayBeforeRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {InsertRowAfterRequest} [insertRowAfterRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public insertRowAfter(
    insertRowAfterRequest?: InsertRowAfterRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardBlocksApiFp(this.configuration)
      .insertRowAfter(insertRowAfterRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {InsertRowBeforeRequest} [insertRowBeforeRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public insertRowBefore(
    insertRowBeforeRequest?: InsertRowBeforeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardBlocksApiFp(this.configuration)
      .insertRowBefore(insertRowBeforeRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {RenameBayRequest} [renameBayRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public renameBay(renameBayRequest?: RenameBayRequest, options?: RawAxiosRequestConfig) {
    return YardBlocksApiFp(this.configuration)
      .renameBay(renameBayRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {RenameRowRequest} [renameRowRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public renameRow(renameRowRequest?: RenameRowRequest, options?: RawAxiosRequestConfig) {
    return YardBlocksApiFp(this.configuration)
      .renameRow(renameRowRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateEquipmentTypesRequest} [updateEquipmentTypesRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateEquipmentTypes(
    updateEquipmentTypesRequest?: UpdateEquipmentTypesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardBlocksApiFp(this.configuration)
      .updateEquipmentTypes(updateEquipmentTypesRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateFlexibleBlockRequest} [updateFlexibleBlockRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateFlexibleBlock(
    updateFlexibleBlockRequest?: UpdateFlexibleBlockRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardBlocksApiFp(this.configuration)
      .updateFlexibleBlock(updateFlexibleBlockRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateYardBlockRequest} [updateYardBlockRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateYardBlock(
    updateYardBlockRequest?: UpdateYardBlockRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardBlocksApiFp(this.configuration)
      .updateYardBlock(updateYardBlockRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateYardBlockLayoutPositionRequest} [updateYardBlockLayoutPositionRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateYardBlockLayoutPosition(
    updateYardBlockLayoutPositionRequest?: UpdateYardBlockLayoutPositionRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardBlocksApiFp(this.configuration)
      .updateYardBlockLayoutPosition(updateYardBlockLayoutPositionRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}
